<template>
	<carousel
		@slide-end="handleSlideEnd"
		ref="carousel"
		class="c-gallery c-gallery--carousel"
		:tabindex="null"
		:aria-label="null"
	>
		<slide v-for="slide in slidesArray" :key="slide">
			<div class="carousel__item" v-html="slide"></div>
		</slide>
	</carousel>

	<div class="c-gallery__footer">
		<div
			class="c-gallery__caption"
			v-html="captionsArray[currentIndex]"
			aria-hidden="true"
		></div>

		<nav class="c-gallery__nav">
			<button @click="prev" aria-label="Previous" class="c-gallery__prev">
				<slot name="prev">←</slot>
			</button>

			<div class="c-gallery__pagination">
				<span v-text="currentIndex + 1"></span> of
				<span v-text="slidesArray.length"></span>
			</div>

			<button @click="next" aria-label="Next" class="c-gallery__next">
				<slot name="next">→</slot>
			</button>
		</nav>
	</div>
</template>

<script>
	import { Carousel, Slide } from "vue3-carousel";

	export default {
		name: "v-gallery-carousel",
		components: {
			Carousel,
			Slide,
		},
		data() {
			return {
				currentIndex: 0,
			};
		},
		props: {
			slideData: {
				type: String,
			},
			captionData: {
				type: String,
			},
		},
		computed: {
			slidesArray: function () {
				return this.slideData ? JSON.parse(this.slideData) : null;
			},
			captionsArray: function () {
				return this.captionData ? JSON.parse(this.captionData) : null;
			},
		},
		methods: {
			prev(e) {
				this.$refs.carousel.prev(e);
			},
			next(e) {
				this.$refs.carousel.next(e);
			},
			handleSlideEnd(data) {
				this.currentIndex = data.currentSlideIndex;
			},
		},
	};
</script>
